/** Design steady state — see docs/PROCESS_MODELS.md §5.2. */
export const designPreset: Record<string, number> = {
  'CWP-201.RUN': 1,
  'CWP-201.CMD': 100,
  'AG-201.RUN': 1,
  'FV-101.CMD': 62,
  'FV-102.CMD': 62,
  'FV-103.CMD': 29,
  'FV-202.CMD': 66,
  'FV-203.CMD': 50,
  'FV-301.CMD': 50,
  'FV-302.CMD': 50,
  'FV-901.CMD': 0,
  'TIC-201.OP': 35,
};
